/**
 * Hook tai du lieu toi thieu: dang tai / loi / du lieu / tai lai.
 *
 * Khong dung thu vien data-fetching vi ca dashboard chi co vai man hinh doc du lieu,
 * va rang buoc cua du an la khong them dependency.
 */

import { useCallback, useEffect, useRef, useState } from 'react';
import { errorMessage } from './api';

export interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useAsync<T>(
  load: (signal: AbortSignal) => Promise<T>,
  deps: ReadonlyArray<unknown>,
): AsyncState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [nonce, setNonce] = useState(0);

  // Giu ham load trong ref: nguoi goi hay truyen arrow function inline, neu dua thang
  // vao deps thi effect chay lai moi lan render -> vong lap fetch vo tan.
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    const controller = new AbortController();
    let alive = true;
    setLoading(true);
    setError(null);

    loadRef.current(controller.signal).then(
      (value) => {
        if (!alive) return;
        setData(value);
        setLoading(false);
      },
      (err: unknown) => {
        if (!alive || controller.signal.aborted) return;
        setError(errorMessage(err));
        setLoading(false);
      },
    );

    return () => {
      alive = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, nonce]);

  const reload = useCallback(() => {
    setNonce((n) => n + 1);
  }, []);

  return { data, loading, error, reload };
}
